import { ReactElement } from 'react'

import {
  ContainerCard,
  ContainerValue,
  DescriptionText,
  MainContainer,
  ValueText,
} from './styles'

export interface DashboardEventTotalCardsProps {
  variateCardDescriptionText: string
  variateValue: string
  children: ReactElement
  isMonetaryValue: boolean
}

export const DashboardGenericCardLocal = ({
  variateCardDescriptionText,
  variateValue,
  children,
  isMonetaryValue,
}: DashboardEventTotalCardsProps) => {
  return (
    <ContainerCard>
      <MainContainer>
        <ContainerValue>
          <DescriptionText>{variateCardDescriptionText}:</DescriptionText>
          {isMonetaryValue ? (
            <ValueText>R$ {variateValue}</ValueText>
          ) : (
            <ValueText> {variateValue}</ValueText>
          )}
        </ContainerValue>
      </MainContainer>
    </ContainerCard>
  )
}
